import { ActionTree } from 'vuex/types/index'
import { RootState } from '~/store/store.types'
import { SohoModel } from '~/constants/SohoModel'
import { formatRelationships } from '~/utils/store'
import { ApplicationSubmission } from '../submissions/submissions.types'

const actions: ActionTree<{}, RootState> = {
  async submitApplication (_, applicationId) {
    const params = formatRelationships({ application: { id: applicationId } }, { application: SohoModel.Application })

    await this.$sohoApi.post<ApplicationSubmission>(SohoModel.ApplicationSubmission, { type: SohoModel.ApplicationSubmission, ...params })
  }
}

export default actions
